<app-header #header title="Appeals"></app-header>

<ion-content fullscreen="true" scrollEvents="true" [appHideHeader]="header" >
  <app-header-content ></app-header-content>
  <app-pagecontent [path]="'lockers'"></app-pagecontent>
  <ion-grid style="min-height: 75%;">
    <ion-row>
      <ion-col size="12">
        <h2 class="subheader-regular" style="text-align: center;">
          {{
            ('keys.data.users_menu.lockers' | translate : {Default:'Lockers'}) || 'Lockers'
            }}
        </h2>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col  class="single-col-wider">
        <ion-searchbar
            [disabled]="!loaded"
            debounce="100"
            
            style="--border-radius: 0.5em"
            inputmode="text"
            [(ngModel)]="searchItem"
            showCancelButton="focus"
            animated
          ></ion-searchbar>
      </ion-col>
    </ion-row>
    <div *ngIf="!loaded">
    <ion-row    *ngFor="let x of [0, 1, 2, 3]">
      <ion-col
    
      class="single-col-wider"
      >
        <ion-card  >
          <ion-card-header  style="
          text-align: center;
          font-weight: bold;
          color: black;
          background: rgba(248, 246, 246, 0.99);
        ">
            <ion-card-subtitle 
              ><ion-skeleton-text
              animated
              style="width: 80%"
            ></ion-skeleton-text
          ></ion-card-subtitle
            >
            <ion-card-title><ion-skeleton-text
            animated
            style="width: 60%"
          ></ion-skeleton-text
        ></ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <ion-accordion-group>
              <div >
                <ion-accordion>
                  <ion-item  toggle-icon="caret-down-circle"
                  slot="header"
                  style="
                    --padding-end: 0px;
                    --inner-padding-end: 0px;
                  ">
                     <ion-title style="text-align: center"
                     ></ion-title
                   >
                  </ion-item>
                  
                </ion-accordion>
              </div>
            </ion-accordion-group>
           
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </div>
  <div *ngIf="loaded && lockers['buildings'].length>0" >
    <ion-row  *ngFor="let building of lockers['buildings'] | keyvalue | filter:searchItem">
     
      <ion-col  class="single-col-wider"
       
       
      >
        <ion-card style="border-radius: 8px;" class="card-shadow-7">
         
          <ion-grid class="ion-no-padding" *ngIf="building.value.Areas" >
            <ion-row  style="background:var(--Blue-Tint, #696ECA)">
              <ion-col style="padding: 0.4em;">
                <ion-label class="card-header-unique" style="color: var(--white, #FFF);text-transform: uppercase;">
                  {{building.value.BuildingName}}
                </ion-label>
              </ion-col>
              
              </ion-row>
              <ion-row>
                <ion-col class="ion-padding">
                  <ion-label class="paragraph-regular">
                    {{building.value.Location}}
                  </ion-label>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col>
                  <ion-accordion-group>
                    <div *ngFor="let area of building.value.Areas">
                      <ion-card class="card-shadow-3">
                      <ion-accordion>
                        <ion-item class="paragraph-input-fields-regular"  toggle-icon="caret-down-circle"
                        slot="header"
                        lines="none"
                        style="
                          --padding-end: 0px;
                          --inner-padding-end: 0px;
                        ">
                           <ion-label 
                           >{{ area.AreaDescr}}</ion-label
                         >
                        </ion-item>
                        <div slot="content">
                          
                            <ion-grid>
                              <ion-row>
                                <ion-col>
                                  <ion-item lines="none" class="paragraph-input-fields-regular">
                                    <ion-label >
                                      {{('keys.data.permits.start_date' | translate : {Default:'Start Date'}) || 'Start Date'}}
                                    </ion-label>
                                    <span 
                                    class="ion-text-wrap"
                                    style="text-align: right"
                                      >
                                      {{area?.SemStart | date:dataService.settings['system']['datemask']}}
                                    </span>
                                  </ion-item>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col>
                                  <ion-item lines="none" class="paragraph-input-fields-regular">
                                    <ion-label >
                                      {{('keys.data.permits.end_date' | translate : {Default:'End Date'}) || 'End Date'}}
                                    </ion-label>
                                    <span 
                                    class="ion-text-wrap"
                                    style="text-align: right"
                                      >
                                      {{area?.SemEnd | date:dataService.settings['system']['datemask']}}
                                    </span>
                                  </ion-item>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col
                                size="12"
                              >
                                <ion-item lines="none">
                                  <ion-label
                                    slot="start"
                                    class="ion-text-wrap"
                                    >
                                    {{area.AreaLockerType}}
                                  </ion-label>
                                  <ion-label
                                    class="ion-text-wrap"
                                    style="text-align: right"
                                    >
                                    {{area.DefaultCost | currency}}
                                  </ion-label>
                                </ion-item>
                              </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col
                                  size="12"
                                 
                                >
                                <ion-item lines="none" class="paragraph-input-fields-regular" style="color:var(--Black-Tint, #626262);">
                                  <ion-label
                                  
                                    class="ion-text-wrap"
                                  >
                                    
                                    {{('keys.data.common.remaining' | translate : {Default:'Remaining'}) || 'Remaining'}}</ion-label
                                  >
                                  <ion-label
                                    class="ion-text-wrap"
                                    style="text-align: right"
                                    >
                                    {{area.available}}
                                  </ion-label>
                                  <ion-label color="danger"
                                    *ngIf="!area.available"
                                    class="ion-text-wrap"
                                    style="text-align: right"
                                  >
                                  {{('keys.data.common.sold_out' | translate : {Default:'Sold Out'}) || 'Sold Out'}}</ion-label
                                  >
                                </ion-item>
                                </ion-col>
                              </ion-row>
                              <ion-row>
                                <ion-col class="ion-text-center">
                                  <ion-button
                                   [disabled]="!area.available || !area.validWindow"
                                    (click)="getLocker(area.BuildingAreaID)"
                                    color="primary"
                                    
                                  >
                                  {{ ('keys.data.lockers.get_locker' | translate : {Default:'Get Locker'} ) || "Get Locker"}}
                                  </ion-button>
                                  
                                </ion-col>
                              </ion-row>
                            </ion-grid>
                         
                        </div>
                      </ion-accordion>
                    </ion-card>
                    </div>
                  </ion-accordion-group>
                </ion-col>
              </ion-row>
            </ion-grid>
          
         
            
           
          
        </ion-card>
      </ion-col>
    </ion-row>
  </div>
    <ion-row  *ngIf="loaded && lockers['buildings'].length<1">
      <ion-col >
        <ion-card>
          <ion-card-content style="text-align: center">
            <ion-label style="font-weight: bold">
              {{ ('keys.data.lockers.no_lockers_available' | translate : {Default:'No lockers available.'} ) ||"No lockers available."}}
            </ion-label>
          </ion-card-content>
        </ion-card>
       </ion-col>
    </ion-row>
  </ion-grid>
  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>
</ion-content>

